/* eslint-disable no-console, no-useless-escape */
const getParameterByName = (name, url) => {
  let location = url;
  if (!location) {
    location = window.location.href;
  }
  const regex = new RegExp(`[?&]${name.replace(/[\[\]]/g, '\\$&')}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(location);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const getUrlSafeHash = str => (
  str.toLowerCase().replace(/[\s|\/]+/g, '-').replace(/\&/g, 'and').replace(/[^a-zA-Z0-9-]+/g, '')
);

export {
  getParameterByName,
  getUrlSafeHash,
};
/* eslint-enable no-console, no-useless-escape */
